import { useMediaQuery } from '@mantine/hooks';
import { DS_AI_REDUCED_MOTION_QUERY } from './reducedMotion.utils';

/** The motion factor for the user's preference: 0 under `prefers-reduced-motion`, else 1; follows a change live. */
export const useDsAiMotionFactor = (): 0 | 1 =>
	useMediaQuery(DS_AI_REDUCED_MOTION_QUERY, false, { getInitialValueInEffect: false }) ? 0 : 1;
